import { features } from './features'; 

features.applicationType = 'agrogest';

// FITOGEST
features.showAnalisis = true;
features.showMotivoFito = true;
features.showPartida = true;
features.puedeImprimir = true;
features.showRegistroTratamiento = true;
features.showEnviarWhatsapp = true;
features.showEnviarCorreo = true;
features.showEnviarWhatsappVisitas = true;
features.showEnviarCorreoVisitas = true;
features.showTareasBio = true;
features.showMeteoBtn = true;
features.showVentusky = true;

// AGROGEST
features.showAplicadoresFichajes = true;
features.showAplicadoresPartes = true;
features.showTrabajadoresCargos = true;
features.showTareasOtros = true;
features.showTareasSiembra = true;
features.showCostes = true;
features.hasClients = false;
features.showStock = true;
features.showStockProveedor = true;
features.showStockEnvase = false;
features.showStockSemilla = true;
features.showSectorPlantas = false;
features.showProductosNumReg = false;
features.fertilizantesNombreRequired = true;
features.fertilizantesUdsMedidaRequired = true;
features.showVisitasConsultas = true;
features.showHistoricoFT = false;
features.showExepcionales = false;
features.showOtrasDenominaciones = false;
features.showRecetaAgrogest = true;
features.showRecetaFertiAgrogest = true;
features.showStockReto = true;
features.showStockTipoDeDato = true;
features.showCostesTareasOtrasCsv = true;
features.showProductosMaxAplicacion = true;
features.showStockProductsColsDistribution = 3;
features.showWidthFertilizanteNombre = true;
features.showStockSemillasColsDistribution = 3;
features.showFertiRoturaStock = true;
features.showFormatHourMinute = true;
features.showTractorMarcha = true;
features.showTractorBoquillas = true;
features.showTractorRPM = true;
features.showTractorPresion = true;
features.showRecetaPascualCabedo = true;
features.precioHora = true;

// Visitas
features.showVisitasVariedades = true;
features.hiddenVisitasCerezo = true;
features.hiddenVisitasContador = true;
features.showVisitasFormAbonosFolques = true;
features.showVisitasFormAbonosFolques = true;
features.showVisitaCarenciasMultiple = true;
features.showMapaLabels = true;
features.showCostesProductos = true;
features.showCostesTareasFertiCsv = true;
features.activateREA = false;
features.activateSIEX = false;
features.showFichajesUbicaciones = true;

export const environment = {
    production: true,
    v: '2',
    serverUrl: 'https://gfcartera.agrogest.com/',
    logoUrl: 'assets/logo_gfcartera.png',
    appName: 'gfcartera',
    features: features
};
